import { SessionData } from 'common/src/BackendLogger/BackendLogger.types'
import { atom } from 'recoil'

export const sessionDataAtom = atom<SessionData>({
    key: 'sessionDataAtom',
    default: {},
})
